import fetchInterceptor, { FetchOptions } from "../../../utils/fetchInterceptor ";
import { getSuperAdminDashboardEndpoint as endpoint } from "../apiEndpoint";
import { header } from "../../../context/constant";

const SuperAdminDashboardApi = async () => {
  const url = endpoint()
  const options: FetchOptions = {
    method: "GET",
    headers: header,
  }
  return fetchInterceptor(url, options)
};
export default SuperAdminDashboardApi;